import useLogAmplitudeEventOnce from '@eversports/amplitude-react/useLogAmplitudeEventOnce'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { fromMapping } from '../../../../App.constants'
import { NotFoundError } from '../../../../App.types'
import LoadingPage from '../../../../components/LoadingPage'
import { useProfilePublicUserQuery } from '../../../../graphql'
import useFromParam from '../../../../hooks/use-from-param'
import useLoggedInUserType from '../../hooks/use-logged-in-user-type'
import { userTypeMapping } from '../../PublicUserProfile.constants'
import { UserType } from '../../PublicUserProfile.types'

import PrivateProfile from './PrivateProfile'
import ProfileComponent from './ProfileComponent'

const Profile = () => {
  const { amplitude, logAmplitudeEventOnce } = useLogAmplitudeEventOnce()
  const { userType } = useLoggedInUserType()
  const { userHandle } = useParams<{ userHandle: string }>()
  const from = useFromParam()

  const { data, loading, error } = useProfilePublicUserQuery({
    variables: { handle: userHandle },
  })

  useEffect(() => {
    if (!error) return

    if (error.graphQLErrors.some(({ extensions }) => extensions?.status === 404)) {
      throw new NotFoundError(`User ${userHandle} was not found`, error.message)
    }

    throw new Error(error.graphQLErrors.map(({ message }) => message).join(' '))
  }, [error])

  useEffect(() => {
    if (!amplitude || !data) return
    logAmplitudeEventOnce({
      eventName: 'Viewed User Profile',
      eventProperties: {
        userType: userTypeMapping[userType],
        from: from ? fromMapping[from] : null,
      },
    })
  }, [amplitude, data])

  if (!data || loading) {
    return <LoadingPage />
  }

  if (data.publicUser.isPrivate && userType !== UserType.PROFILE_OWNER) {
    return <PrivateProfile />
  }

  return <ProfileComponent user={data.publicUser} />
}

export default Profile
